import { Component } from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'app-home-footer',
  imports: [CommonModule],
  templateUrl: './home-footer.component.html',
  styleUrl: './home-footer.component.scss',
})
export class HomeFooter {
  currentYear = new Date().getFullYear();
}
